import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { SelectOption } from '../types';

interface SingleCheckboxProps {
  label: string;
  selectedValue: string;
  inputOption: SelectOption;
  saveSingleSelection: (value: string) => void;
  renderValidationErrors: () => boolean | JSX.Element;
}

export default (props: SingleCheckboxProps) => {
  const {
    label,
    selectedValue,
    inputOption,
    saveSingleSelection,
    renderValidationErrors
  } = props;

  const handleCheckboxChange = () => {
    if (selectedValue) {
      saveSingleSelection('');
    } else {
      saveSingleSelection(inputOption.value);
    }
  };

  return (
    <>
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup>
        <FormControlLabel
          label={inputOption.value}
          control={
            <Checkbox
              checked={selectedValue === inputOption.value}
              onChange={handleCheckboxChange}
            />
          }
        />
      </FormGroup>
      {renderValidationErrors()}
    </>
  );
};
